import { LimitedSchemaMutationOptions, useMutation } from '@frontend/react-query-helpers';
import { SchemaDigitalForms } from '@frontend/schema';
import { IO } from '../../types';
import { endpointKeys } from '../keys';

export const useCreateFormLinks = <E = unknown, C = unknown>(
  options?: LimitedSchemaMutationOptions<IO.CreateFormLinks, E, C>
) => {
  return useMutation({
    mutationKey: endpointKeys.createFormLinks,
    mutationFn: (req) => SchemaDigitalForms.CreateFormsLink(req),
    ...options,
  });
};
